// extracted by mini-css-extract-plugin
export default {"navItem":"styles_navItem__2xu6L","navbarContainer":"styles_navbarContainer__UWnYL","offcanvasItem":"styles_offcanvasItem__Fn2D-"};